import { getFramework } from '@/framework';
import { isHotKeyPress } from '@/utils/event-kit';
import { ILayerProps } from '@/version-types';

export const supportUnequalStretch = (identity: string, layer: ILayerProps) => {
    const framework = getFramework(identity);
    const lockRatio = layer.extraInfo?.lockRatio ?? true;
    const { right, bottom } = framework.service.flatLayer.checkCanResizeOperate(layer);

    const supportUnequalStretch = right && bottom;

    //如果两条边不支持拉伸，则不支持不等比缩放
    if (!supportUnequalStretch) return false;

    const hotKeyPressed = isHotKeyPress();

    // 根据 lockRatio 和 hotKeyPressed 返回判断结果
    // 如果lockRatio为true，如果shift键被按下，则不等比缩放,否则等比缩放
    // 如果lockRatio为false，如果shift键被按下则等比缩放，否则不等比缩放
    return lockRatio ? hotKeyPressed : !hotKeyPressed;
};
